import { useContext } from "react"
import { Alert, Form, Input } from "antd"
import BaseModal from "../../../components/layout/BaseModal"
import { ModalContext } from "../../../components/contexts/ModalContext"
import PasswordRequirementsList, { passwordConfirmFieldRules, passwordFieldRules } from "../../../components/elements/PasswordRequirementsList"
import { useSetEmployeePasswordMutation } from "../api/services"

type TSetPasswordForm = {
    password: string
    confirmPassword: string
}

type SetPasswordModalType = {
    modalId: number
    kcid: string
    employeeName: string
}

/** Administrator setzt das Passwort eines Mitarbeiters (PUT /kc/user/:kcid/password); Regeln wie im Backend. */
export default function SetPasswordModal(props: SetPasswordModalType) {
    const modalCon = useContext(ModalContext)
    const [form] = Form.useForm<TSetPasswordForm>()
    const password = Form.useWatch("password", form) ?? ""
    const confirmPassword = Form.useWatch("confirmPassword", form) ?? ""

    const { mutate: setPassword, isPending, reset } = useSetEmployeePasswordMutation()

    // Erfolg: Formular leeren, Mutationszustand zurücksetzen (wie beim Schließen über onClose) und Modal schließen
    const close = () => {
        form.resetFields()
        reset()
        modalCon?.trigger(0)
    }

    return (
        <Form<TSetPasswordForm> form={form} layout="vertical" requiredMark={false} onFinish={(values) => setPassword({ kcid: props.kcid, newPassword: values.password }, { onSuccess: close })} disabled={isPending}>
            <BaseModal
                title={"Passwort setzen: " + props.employeeName}
                modalId={props.modalId}
                size="fit"
                onClose={() => {
                    form.resetFields()
                    reset()
                }}
                bottomRow={
                    <div className="flex flex-row justify-end">
                        <button type="submit" className="btn btn-primary" disabled={isPending}>
                            {isPending && <span className="loading loading-spinner" />}
                            Passwort setzen
                        </button>
                    </div>
                }>
                <div className="flex flex-col gap-2 p-2 md:w-[28rem]">
                    <Alert type="info" showIcon message="Der Mitarbeiter erhält das neue Passwort per E-Mail." description="Alle laufenden Sitzungen des Mitarbeiters werden beendet." />
                    <Form.Item label="Neues Passwort" name="password" rules={passwordFieldRules} className="mb-2">
                        <Input.Password autoComplete="new-password" size="large" />
                    </Form.Item>
                    <Form.Item label="Passwort wiederholen" name="confirmPassword" dependencies={["password"]} rules={passwordConfirmFieldRules("password")} className="mb-2">
                        <Input.Password autoComplete="new-password" size="large" />
                    </Form.Item>
                    <PasswordRequirementsList password={password} confirmPassword={confirmPassword} />
                </div>
            </BaseModal>
        </Form>
    )
}
